module.exports = Promise.resolve(module.bundle.root("4yw4p"))